"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInstance = void 0;
var axios_1 = __importDefault(require("axios"));
var catalogues = __importStar(require("./resources/catalogues"));
var jobs = __importStar(require("./resources/jobs"));
var contacts = __importStar(require("./resources/contacts"));
var users = __importStar(require("./resources/users"));
var emails = __importStar(require("./resources/emails"));
var payments = __importStar(require("./resources/payments"));
var quotes = __importStar(require("./resources/quotes"));
var reports = __importStar(require("./resources/reports"));
var worksheets = __importStar(require("./resources/worksheets"));
var suppliers = __importStar(require("./resources/suppliers"));
var vehicles = __importStar(require("./resources/vehicles"));
var notifications = __importStar(require("./resources/notifications"));
var createInstance = function (config) {
    var axiosInstance = axios_1.default.create(config);
    var mapResource = function (resource) {
        return Object.entries(resource).reduce(function (final, _a) {
            var _b;
            var _c = __read(_a, 2), fnName = _c[0], api = _c[1];
            return __assign(__assign({}, final), (_b = {}, _b[fnName] = api(axiosInstance), _b));
        }, {});
    };
    return {
        catalogues: mapResource(catalogues),
        jobs: mapResource(jobs),
        contacts: mapResource(contacts),
        users: mapResource(users),
        emails: mapResource(emails),
        payments: mapResource(payments),
        notifications: mapResource(notifications),
        quotes: mapResource(quotes),
        reports: mapResource(reports),
        worksheets: mapResource(worksheets),
        suppliers: mapResource(suppliers),
        vehicles: mapResource(vehicles),
        axios: axiosInstance,
    };
};
exports.createInstance = createInstance;
